import { render, staticRenderFns } from "./AppCookiebar.vue?vue&type=template&id=2ae30d22&scoped=true&"
import script from "./AppCookiebar.vue?vue&type=script&lang=js&"
export * from "./AppCookiebar.vue?vue&type=script&lang=js&"
import style0 from "./AppCookiebar.vue?vue&type=style&index=0&id=2ae30d22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae30d22",
  null
  
)

export default component.exports